/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  WrapperFactory,
  WrapperFactoryInterface,
} from "../WrapperFactory";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_libraryAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_holderAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "proxyAddress",
        type: "address",
      },
    ],
    name: "WrapperCreated",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
    ],
    name: "createWrapper",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "getWrapper",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "holderAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "libraryAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class WrapperFactory__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _libraryAddress: string,
    _holderAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<WrapperFactory> {
    return super.deploy(
      _libraryAddress,
      _holderAddress,
      overrides || {}
    ) as Promise<WrapperFactory>;
  }
  getDeployTransaction(
    _libraryAddress: string,
    _holderAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _libraryAddress,
      _holderAddress,
      overrides || {}
    );
  }
  attach(address: string): WrapperFactory {
    return super.attach(address) as WrapperFactory;
  }
  connect(signer: Signer): WrapperFactory__factory {
    return super.connect(signer) as WrapperFactory__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): WrapperFactoryInterface {
    return new utils.Interface(_abi) as WrapperFactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): WrapperFactory {
    return new Contract(address, _abi, signerOrProvider) as WrapperFactory;
  }
}
